<template>
  <div id="app">
    <section class="w-full relative">
      <div v-if="!route.meta.authUserRoutes" class="half-white"></div>
      <div v-if="!route.meta.authUserRoutes" class="image-container"></div>
      <Navbar id="navbar" v-if="!route.meta.requiresAuth" />
      <Topbar
        id="topbar"
        v-if="route.meta.requiresAuth"
        class="ml-0 lg:ml-[350px]"
        :openSidebar="openSidebar"
        :closeSidebar="closeSidebar"
      />
      <Sidebar
        id="sidebar"
        v-if="route.meta.requiresAuth"
        class="lg:ml-0 w-[350px]"
        :class="{ '-ml-[350px]': sidebar === false }"
        :closeSidebar="closeSidebar"
      />
      <main
        :class="
          route.meta.requiresAuth
            ? 'lg:ml-[350px] ml-0 bg-white px-5 py-[30px] lg:p-[40px] mainView'
            : 'p-5 lg:px-[40px] xl:px-[100px]'
        "
      >
        <RouterView class="container mx-auto"></RouterView>
        <footer
          v-if="route.meta.showFooter && !route.meta.authUserRoutes"
          class="max-[481px]:mt-[10px] flex justify-center items-center gap-[14px] lg:pb-[130px] lg:mt-5"
        >
          <img src="./assets/images/logo.png" width="40" height="40" />
          <img src="./assets/images/mfu_logo.png" width="40" height="40" />
          <img src="./assets/images/triangle_logo.png" width="40" height="40" />
          <img src="./assets/images/elephant_logo.png" width="40" height="40" />
          <img
            src="./assets/images/public_health_logo.png"
            width="40"
            height="40"
          />
          <img src="./assets/images/NIRR.png" width="40" height="40" />
        </footer>
      </main>
    </section>
    <StatusModal ref="statusModal" />
    <Loader id="loader" class="loader fixed top-0" ref="loader" />
  </div>
</template>
<script setup>
import axios, {
  registerLoaderRef,
} from "./components/Utilities/javascripts/axios";
import StatusModal from "./components/Modals/StatusModal.vue";
import Topbar from "./components/Layout/Topbar.vue";
import Navbar from "./components/Layout/Navbar.vue";
import Sidebar from "./components/Layout/Sidebar.vue";
import Loader from "./components/Layout/Loader.vue";
import { provide, onMounted, computed, ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const loader = ref(null);
const sidebar = ref(Boolean);
const statusModal = ref(null);
provide("statusModal", statusModal);

const routesWithoutLayout = ["/dashboard", "/disaster"];

// ตรวจสอบว่าควรแสดงองค์ประกอบของเลย์เอาต์หรือไม่
const ShowElements = computed(() => {
  return !routesWithoutLayout.includes(route.path);
});

const showSidebar = computed(() => {
  return route.meta.requiresAuth;
});

const openSidebar = () => {
  sidebar.value = true;
};

const closeSidebar = () => {
  sidebar.value = false;
};

provide("validateMsg", (errorObj) => {
  let errorMessages = null;
  if (Array.isArray(errorObj)) {
    errorMessages = {};
    Object.keys(errorMessages).forEach(function (key) {
      errorMessages[key] = "";
    });
    Object.keys(errorObj).forEach(function (key) {
      errorMessages[key] = errorObj[key][0];
    });
  } else {
    errorMessages = errorObj;
  }
  return errorMessages;
});

provide("loader", loader);

onMounted(() => {
  registerLoaderRef(loader);
  // console.log(axios.defaults.baseURL);
});
</script>

<style scoped>
.image-container {
  background: url("/images/background-img.jpg") lightgray 50% / cover no-repeat;
  height: 100vh;
  width: 100%;
  position: fixed;
  z-index: -2;
  transform: scale(1.1);
  left: 0;
  top: 0;
  @media (max-width: 1024px) {
    display: none;
  }
}

.half-white {
  position: fixed;
  /* margin-top: 90px; */
  width: 100%;
  height: 70%;
  background: linear-gradient(180deg, white, #ffffff00);
  z-index: -1;
}

.sidebar-fixed {
  width: 260px;
  min-height: 100vh;
  position: sticky;
  top: 0;
  z-index: 2;
}

.content-with-sidebar {
  width: calc(100% - 260px);
  /* ปรับตามความกว้างของ Sidebar */
  padding-left: 1rem;
}

.mainView {
  min-height: calc(100vh - 91px);
   @media (min-width: 40rem) {
    padding-bottom: 50px;
  }
}
</style>
